import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  spacerSize?: number;
  disableMinusMarginX?: boolean;
}

export const ModalFooter = ({ children, className, spacerSize, disableMinusMarginX }: Props) => (
  <>
    <div style={{ marginTop: `${spacerSize || 0}rem` }} />
    <div className={classNames('-mb-8 sticky bottom-0 right-0 z-10', { '-mx-6': !disableMinusMarginX })}>
      <div className="h-5 border-b border-b-gray-2 bg-gradient-to-b from-transparent to-[#f6f8fa]" />
      <div
        className={classNames(
          'flex',
          'items-center',
          'justify-end',
          'px-6',
          'py-4',
          'gap-x-4',
          'gap-y-2',
          'bg-white',
          className,
        )}
      >
        {children}
      </div>
    </div>
  </>
);
